<template>
      <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
  <div style="overflow-x: hidden;overflow-y: auto; width: 100%;height:90%;margin-top: 2%;display: flex;justify-content: center;"
       v-loading="loding">
    <div style="width: 90%;">
    <!-- <div style="text-align: center;">会展财务总结</div> -->
    <div style="margin-top: 2%;">会展主题：{{ Summary.exhibitionTheme }}</div>
    <div>会展时间：{{ (Summary.starData||'').split('T')[0] }}至{{ (Summary.endData||'').split('T')[0] }}</div>
    <div>总结部门：财务管理</div>
    <div>总结内容：本次会展在策划时共提交了<span class="span">{{ Summary.budgetCount }}</span>次预算,
      其中<span class="span">{{ Summary.budgetRefuse }}</span>次未通过审批,
      <span class="span">{{ Summary.budgetApproved }}</span>次通过审批,
      本次展会预算费用为:设计费用为<span class="span">{{ Summary.designCost }}</span>元,
      专家费用的预算为<span class="span">{{ Summary.expertFees }}</span>元,
      宣传推广费用为<span class="span">{{ Summary.promotionExpenses }}</span>元,
      招商费用为<span class="span">{{ Summary.attractInvestment }}</span>元,
      媒体费用为<span class="span">{{ Summary.mediaCost }}</span>元,
      场地租赁费用<span class="span">{{ Summary.venueCost }}</span>元,
      其他费用<span class="span">{{ Summary.otherCost }}</span>元。
    </div>
    <div>本次展会实际总支出为<span class="span">{{ Summary.totalExpenditure }}</span>元,
      本次展会实际总收入为<span class="span">{{ Summary.totalIncome }}</span>元,
      设计费用为<span class="span">{{ Summary.designCosts }}</span>元,
      人员费用为<span class="span">{{ Summary.employeeCost }}</span>元,
      专家费用为<span class="span">{{ Summary.expertCost }}</span>元,
      宣传推广费用为<span class="span">{{ Summary.marketingCost }}</span>元,
      招商费用为<span class="span">{{ Summary.attractInvestmentCost }}</span>元,
      媒体费用为<span class="span">{{ Summary.mediaCosts }}</span>元,
      场馆费用为<span class="span">{{ Summary.venueCosts }}</span>元,
      会场费用为<span class="span">{{ Summary.venueFees }}</span>元,
      茶点费用为<span class="span">{{ Summary.teaCost }}</span>元,
      正餐费用为<span class="span">{{ Summary.dinCost }}</span>元,
      活动费用为<span class="span">{{ Summary.activityCost }}</span>元,
      秩序维护花费为<span class="span">{{ Summary.orderMaintenance }}</span>元,
      企业数据购买花费为<span class="span">{{ Summary.enterprisePurchaseCost }}</span>元,
      门票收入为<span class="span">{{ Summary.ticketIncome }}</span>元,
      主题演讲收入为<span class="span">{{ Summary.keynoteIncome }}</span>元。
      广告收入为<span class="span">{{ Summary.advertisingIncome }}</span>元,
      大展位收入为<span class="span">{{ Summary.largeBoothIncome }}</span>元,
      小展位收入为<span class="span">{{ Summary.smallBoothIncome }}</span>元,
      中展位收入为<span class="span">{{ Summary.mediumBoothIncome }}</span>元。
    </div>
    <div>本次展会共申请开具<span class="span">{{ Summary.invoiceCount }}</span>张发票,其中专票<span class="span">{{ Summary.specialTicket }}</span>张,
      普票<span class="span">{{ Summary.universalTicket }}</span>张。</div>
    <div class="drawerDiv">
      <div id="chartSG"
           v-if="true"></div>
    </div>
  </div>
  </div>
</ShowControl>
</template>
  
  <script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  components: {ShowControl},
  data () {
    return {
      Summary: {},
      Summarys: {},
      loding: false,
      checkSummarize: 0,
      flowID: localStorage.getItem("flowID"),
      title: '财务数据总结'
    }
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      ChatShow:(state) => state.user.chatShows,
    }),

  },
  mounted () {
    this.drawSg();
    this.$refs.showControl.receiveValue(true);
  },
  created () {
    //this.GetFinancialSummary()
  },
  methods: {
    revertClick(){
      this.$router.push("/FinancialManagement")
    },
    drawSg () {
      this.loding = true;
      var chartDom = document.getElementById('chartSG');
      var myChart = this.echarts.init(chartDom);
      var option;
      this.$http
        .get(`FinanceStatistics/GetFinancialSummary?round=${this.Round}`)
        .then((res) => {
          if (res.success) {
            this.Summarys = res.dynamicObj;
            this.Summary = res.dynamicObj.result;
            option = {
              backgroundColor: '#fff',
              series: [
                {
                  type: 'sankey',
                  data: this.Summarys.data,
                  links: this.Summarys.link,
                  emphasis: {
                    focus: 'adjacency'
                  },
                  lineStyle: {
                    color: 'gradient',
                    curveness: 0.5
                  }
                }
              ],
              tooltip: {
                trigger: 'item',
                triggerOn: 'mousemove'
              }
            };
            option && myChart.setOption(option);
            if (this.flowID == this.Global.FlowList.实验总结) {
              let that = this;
              let checkSummarize = that.$store.state.user.checkSummarize;
              if ((that.$store.state.user.checkSummarize & (1 << 4)) == 0) {
                checkSummarize += 16;
                this.checkSummarize = checkSummarize;
                that.$store.commit("checkSummarizecomit", checkSummarize);
              }
            }
            this.loding = false;
            if(this.flowID == 5){
              this.$http
                .get(`StudentData/GetStepOperation?stepID=${this.Global.OperateType.查看财务数据总结}&round=${this.Round}`)
                .then((res) => {
                  if (res.success) {
                    this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.查看财务数据总结 });  
                  }
                })
            }
          } else {
            return this.$message.error(res.message);
          }
        });
    },
    GetFinancialSummary () {
      this.$http.get(`FinanceStatistics/GetFinancialSummary?round=${this.Round}`).then((res) => {
        if (res.success) {
          this.Summary = res.dynamicObj
        } else {
          this.$message.console.error(res.message);
        }
      })
    }
  },
  watch: {
    checkSummarize (newVal, oldVal) {
      if (newVal == 31) {
        if (this.flowID == this.Global.FlowList.实验总结) {
          this.$http.get(`User/SummarizeScore?round=${this.Round}`).then((res) => {
            if (res.success) {
              let that = this;
              let checkSummarize = that.$store.state.user.checkSummarize;
              checkSummarize += 1;
              this.checkSummarize = checkSummarize;
              that.$store.commit("checkSummarizecomit", checkSummarize);
            }
          })
        }
      } else {
        console.log(oldVal)
      }
    }
  }
}
  </script>
  
<style scoped>
.span {
  color: red;
}
.drawerDiv {
  height: 100%;
  display: flex;
  justify-content: center;
}
#chartSG {
  width: 825px;
  height: 580px;
  color: white;
}
</style>